import { UiKitCheckboxTag } from '@/fo/ui/kit/checkbox/tag';

import { FilterOption } from '../../../types';
import { FilterComponentProps } from '../types';

import { styles } from './LabelListFilter.styles';

/** Компонент для отображения label фильтров */
export function LabelListFilter({
  options,
  selected,
  onChange,
  disabled
}: FilterComponentProps) {
  const slots = styles();

  return (
    <div className={slots.base()}>
      {(options as FilterOption[]).map((option) => {
        const isSelected =
          Array.isArray(selected) &&
          selected.some((value) => value === option.value);
        return (
          <UiKitCheckboxTag
            key={option.value}
            label={option.label}
            checked={isSelected}
            disabled={disabled}
            onChange={(checked) => onChange(option.value, checked)}
          />
        );
      })}
    </div>
  );
}
